<template>
    <!--sidebar-->
    <aside class="sidebar">
        <trending></trending>
        <videos></videos>
        <section-link link="https://www.welcometopalestine.com/history-of-palestine/" image="https://www.welcometopalestine.com/wp-content/uploads/2017/03/History.jpg" alt="kid holding book under sunlight rays coming from a broken ceiling" message="History of Palestine">
            The region consisting of Palestine, Syria, Jordan and Lebanon forms a land bridge between the continents of Europe, Asia and Africa. Any animal, plant, or human (that cannot fly) has to pass through it to get from one of these continents to one of the others.
        </section-link>
        <section-link link="https://www.welcometopalestine.com/destinations/" image="https://www.welcometopalestine.com/wp-content/uploads/2017/03/Destinationsnews.jpg" alt="bethlehem busy street" message="Destinations">
            <ul>
                <li><a href="/destinations/bethlehem/">Bethlehem</a></li>
                <li><a href="/destinations/gaza">Gaza</a></li>
                <li><a href="/destinations/hebron/">Hebron</a></li>
                <li><a href="/destinations/jenin">Jenin</a></li>
                <li><a href="/destinations/jericho">Jericho</a></li>
                <li><a href="/destinations/jerusalem">Jerusalem</a></li>
                <li><a href="/destinations/">More...</a></li>
            </ul>
        </section-link>
        <section-link link="https://www.welcometopalestine.com/food/" image="https://www.welcometopalestine.com/wp-content/uploads/2017/03/Yogurt-and-Cucumber-Dip-GF.jpg" alt="Yogurt and mint dip" message="Food">
            <ul>
                <li><a href="/food/vegetarian">Vegetarian</a></li>
                <li><a href="/food/seafood">Seafood</a></li>
                <li><a href="/food/meat">Meat</a></li>
                <li><a href="/food/salada">Salad</a></li>
                <li><a href="/food/breakfast">Breakfast</a></li>
                <li><a href="/food/soups-and-stews">Soups & Stews</a></li>
                <li><a href="/food/">More...</a></li>
            </ul>
        </section-link>
        <section-link link="https://www.welcometopalestine.com/getting-in/the-west-bank/" image="https://www.welcometopalestine.com/wp-content/uploads/2016/09/getting-In-westbank-1.jpg"></section-link>
        <section-link link="https://www.welcometopalestine.com/getting-in/gaza/" image="https://www.welcometopalestine.com/wp-content/uploads/2016/09/getting-In-gaza-2.jpg"></section-link>
        <!--<latest></latest>-->
    </aside>
</template>

<script>
	import Trending from "./trending.vue";
	import Videos from "./videos.vue";
	import SectionLink from "./section-link.vue";
    export default {
        components: {
        	Trending,
            Videos,
            SectionLink
        }
    }
</script>


// WEBPACK FOOTER //
// sidebar.vue?560335f8